import { BaseDataBind } from "./base";

/**
 * Data bind type of element's innerHTML property.
 * Used for <textarea> and for any element with contenteditable property.
 */
export class ContentDataBind extends BaseDataBind
{
    public attributeName = 'data-bind-content';
    public selector = '[data-bind-content]';
    public eventNames = ['input'];

    protected setElementValue(element: Element, value: any)
    {
        element.innerHTML = value;
    }

    protected getElementValue(element: Element): any
    {
        return element.innerHTML;
    }
}